import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "fab-menu fab-menu-fixed fab-menu-bottom-right",
  "data-fab-toggle": "click"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fab-icon-open icon-question7" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fab-icon-close icon-question7" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", null, [
      _createElementVNode("a", {
        class: "fab-menu-btn btn bg-info btn-float rounded-circle btn-icon",
        "data-toggle": "dropdown",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showModal && _ctx.showModal(...args)))
      }, _hoisted_4)
    ])
  ]))
}